import Interieur from "./Interieur";

/**
 * Ein Interieur, das sich wie eine Tür verhält und DragHandles oben und unten hat
 */
export default class FullHeightDragable extends Interieur {
    // DO NOT CHANGE
    className = "FullHeightDragable";

    fullHeightDrag = true;

    // dies ist ein kurzzeit-Flag, das nur einen Compileschritt Gültigkeit hat
    // und was dafür sorgt, das Türen, die bis zum oberen Rand gehen, bei Größenänderungen
    // des Elements diesem folgen
    followTopOfElement = false;

    constructor(type: string, element: ?Object) {
        super(type, element);
    }

    _compileSize() {
        super._compileSize();
        this._followTopOfElement();
    }

    _followTopOfElement() {
        if (!this.element || !this.isDropped) {
            return;
        }

        // Lässt die Tür der oberen Element-Grenze folgen

        const y = this.y;
        const top = this.size.y + y;
        const maxY = this.canTopBeSlopedInElement(this.element) ? this.element.box.max.y : this.element.slopeTop;
        const setToTop = this.followTopOfElement || top > maxY;

        if (setToTop) {
            this.size.y = maxY - y;
            this.y = y;
        }

        this.followTopOfElement = false;
    }

    acceptElement(element) {
        return true;
    }

    setFollowTopOfElement() {
        this.followTopOfElement = Math.abs((this.size.y + this.y) - this.element.box.max.y)<1;
    }

    static maybeSetFollowTopOfElement(interieur) {
        if (interieur.setFollowTopOfElement) {
            interieur.setFollowTopOfElement()
        }
    }

}

